import { Card, Typography, CardHeader, Stack, Grid } from '@mui/material';
import { useAppSelector } from '../../../store';

interface IProfile {
  email: string;
  mobileNumber: string;
  countryCode: string;
}

const ProfileAbout: React.FC<IProfile> = ({
  email,
  mobileNumber,
  countryCode,
}) => {
  const userProfile = useAppSelector((state) => state.auth.user);

  return (
    <Card sx={{ padding: '8px 8px 16px 8px' }}>
      <CardHeader title='Personal Information' />
      <Grid
        container
        spacing={2}
        m={1}
      >
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
        >
          <Stack direction='row'>
            <i className='fa-sharp fa-solid fa-user user-profile-icon-class'></i>
            <Typography variant='subtitle2'>{'Role'}&nbsp;</Typography>
            <Typography
              variant='body2'
              className='text-capital'
            >
              {userProfile?.userRole}
            </Typography>
          </Stack>
        </Grid>
        {email && (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
          >
            <Stack direction='row'>
              <i className='fa-sharp fa-solid fa-envelope user-profile-icon-class'></i>
              <Typography variant='subtitle2'>{'Email'}&nbsp;</Typography>
              <Typography variant='body2'>{email}</Typography>
            </Stack>
          </Grid>
        )}

        {mobileNumber && (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
          >
            <Stack direction='row'>
              <i className='fa-sharp fa-solid fa-phone user-profile-icon-class'></i>
              <Typography variant='subtitle2'>
                {'Phone Number'}&nbsp;
              </Typography>
              <Typography variant='body2'>
                {countryCode} - {mobileNumber}
              </Typography>
            </Stack>
          </Grid>
        )}
      </Grid>
    </Card>
  );
};
export default ProfileAbout;
